import { render, staticRenderFns } from "./InvestmentManagerBasePage.vue?vue&type=template&id=2d1518d2&"
import script from "./InvestmentManagerBasePage.vue?vue&type=script&lang=js&"
export * from "./InvestmentManagerBasePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports